import { WbWidget } from '@agilelab/plugin-wb-platform';
import { GenericContent } from './GenericContent';

type Props = {
  title: string;
  values: any;
  defaultText?: string;
};

export const GenericWidget = (props: Props) => {
  return (
    <WbWidget title={props.title}>
      <GenericContent {...props} />
    </WbWidget>
  );
};
